interface IconProps {
  className?: string;
}

const OrderIcon: React.FC<IconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        width="32"
        height="32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 10h13.09a2 2 0 0 1 1.966 2.369l-.75 4A2 2 0 0 1 22.84 18h-9.2a2 2 0 0 1-1.962-1.608l-1.356-6.784A2 2 0 0 0 8.36 8H6"
          className="stroke-current"
          strokeWidth="2"
        />
        <circle
          cx="14"
          cy="22"
          r="1"
          transform="rotate(-180 14 22)"
          className="stroke-current"
          strokeWidth="2"
        />
        <circle
          cx="22"
          cy="22"
          r="1"
          transform="rotate(-180 22 22)"
          className="stroke-current"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};

export default OrderIcon;
